import type { AccountNode } from '@taler/api-client'

/** The ledger's default write-off target for a forgiven contact receivable. */
export function giftsAccountId(nodes: readonly AccountNode[]): string | undefined {
  for (const node of nodes) {
    if (node.account.code === 'EXPENSE.GIFTS') return node.account.id
    const found = giftsAccountId(node.children)
    if (found !== undefined) return found
  }
  return undefined
}
